import { CollapseDrawerContextProps } from './types';

export const DEFAULT_STATE: CollapseDrawerContextProps = {
  collapseClick: false,
  collapseHover: false,
  onToggleCollapse: () => { console.log('onToggleCollapse'); },
  onHoverEnter: () => { console.log('onHoverEnter'); },
  onHoverLeave: () => { console.log('onHoverLeave'); },
};
